<template>
    <div class="relative w-full max-w-xl bg-white shadow-lg rounded p-4 md:p-8 mt-4">
        <div class="mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                for="leadPhone">Your number</label>

            <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="tel"
                id="leadPhone"
                v-model="leadPhone">
        </div>

        <div class="flex">
            <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded border-none"
                type="submit"
                @click="updateAndCall">
                Yes, call again
            </button>

            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold ml-2 py-2 px-4 rounded border-none"
                type="submit"
                @click="updateAndSchedule"
                v-if="hasCalendly">
                Schedule appointment
            </button>

            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold ml-2 py-2 px-4 rounded border-none"
                type="submit"
                @click="updateAndClose"
                v-else>
                Close
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                leadPhone: this.$store.getters.leadPhone
            }
        },

        computed: {
            ...mapGetters([
                'hasCalendly',
                'leadHash'
            ])
        },

        methods: {
            update() {
                const payload = {
                    phone: this.leadPhone
                };

                this.$http.put(route('api.lead.update', this.leadHash), payload)
                    .then(({data}) => {
                        this.$store.commit('leadPhone', data.phone);
                    })
                    .catch(() => {
                        this.$store.commit('modal', 'call-error');
                    });
            },

            updateAndCall() {
                this.update();

                this.$event.$emit('retry-call');
            },

            updateAndClose() {
                this.update();

                this.$event.$emit('close-modal');
            },

            updateAndSchedule() {
                this.update();

                this.$store.commit('modal', 'schedule-appointment');
            }
        },
    }
</script>
